import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import formatPrice from '@honda-canada/js-utilities/lib/formatPrice';
import { LabeledCheckbox } from '../shared/LabeledItem';
import { useLanguage } from '../../../utils/sitecoreContext';
const OfferItem = ({ id, isSelected, label, name, tooltip, disableAllFields, onCheckboxClick, suppressSelected, value, }) => {
    const language = useLanguage();
    const priceValue = value;
    let priceContent = '';
    if (Array.isArray(value)) {
        if (+value[0] !== 0) {
            priceContent = `${value[0]}%`;
        }
        else {
            priceContent = `-${formatPrice(value[1], language, 2)}`;
        }
    }
    else {
        priceContent = `-${formatPrice(priceValue, language, 2)}`;
    }
    return (_jsx(LabeledCheckbox, { checked: isSelected, onClick: () => onCheckboxClick === null || onCheckboxClick === void 0 ? void 0 : onCheckboxClick(!isSelected, id), label: label || name, tooltipText: tooltip, name: name, dataTestId: `cy-offer-item-checkbox-${id}`, disabled: disableAllFields, rightSideText: priceContent, suppressSelected: suppressSelected }, id));
};
export default OfferItem;
